module.exports = __webpack_public_path__ + "img/science.9623b3d9.png";